export const API = {
  video: "/video",
  videoLabel: "/video-label",
  videoList: "/video-list",
  marker: "/video-marker",
  videoHighlight: "/video-highlight",
  gif: "/loader-media",
  analytic: "/video-analytic",
};
